export enum SalesChannelValues {
  ONLINE_STORE = "online_store",
  OTHER = "other",
}
